// Tone.js is a full synthesis library — a disproportionate chunk of the eagerly-loaded main
// bundle for the few short sound effects and one-time AudioContext unlock this app needs it
// for. Loaded on first actual use instead (and cached), so a cold visit never pays for it.
let toneModulePromise = null;
export const loadTone = () => {
    if (!toneModulePromise) toneModulePromise = import('tone');
    return toneModulePromise;
};
